import { CHANGE_PASSWORD, UPDATE_USER_PROFILE, SAVE_UPDATED_PROFILE_IMAGE, UNLINK_FACEBOOK } from './action.type'
import $axios from '../../helpers/axios-instance'

export default {
    [CHANGE_PASSWORD](context, passwordDetails) {
       return new Promise((resolve, reject) => {
           $axios.patch('/user/changePassword', {
               ...passwordDetails
           }).then(response => {
               resolve(response);
           }).catch(error => {
               reject(error);
           })
       })
    },

    [SAVE_UPDATED_PROFILE_IMAGE](context, uploadedImage) { 
        return new Promise((resolve, reject) => {
            $axios.post('/user/uploadImage', {
                ...uploadedImage
            }, {
                timeout: 500000
            }).then(response => {
                resolve(response);
            }).catch(error => {
                console.log(error)
                reject(error);
            })
        })
    },

    [UPDATE_USER_PROFILE](context, body) {
        return new Promise((resolve, reject) => {
            $axios.patch('/user/updateProfile', {
                ...body
            }).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    },

    [UNLINK_FACEBOOK](context, fbToken) {
        return new Promise((resolve, reject) => {
            $axios.patch('/user/linkUnlinkFacebook', {
                facebookAccessToken : fbToken
            }, {
                timeout: 500000
            }).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    }
}